import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { LoadingScreenService } from "./loading-screen.service";
import { PreferenceService } from "./preference.service";
import { CategoryTagSyncService } from "./category-tag-sync.service";

@Injectable({
  providedIn: "root"
})
export class PreferencesResolver {
  constructor(
    private readonly prefs: PreferenceService,
    private readonly loadingScreen: LoadingScreenService,
    private readonly categoryTagSync: CategoryTagSyncService
  ) { }

  async resolve(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Promise<any> {
    this.loadingScreen.startLoading();
    await this.prefs.initialize();

    // After initialize(): the gate reads tenant capabilities, which the guard doesn't have yet.
    void this.categoryTagSync.syncAsync();
  }
}
